export default function() {
  return {
    mockGps: [],
    failedJobs: [],
    jobs: []
  }
}
